import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  styled,
  TextField,
  CircularProgress,
  InputAdornment,
  IconButton,
} from "@mui/material";
import useAuthentication from "../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { getPivilegesServices, loginServices } from "../../services/services";
import {
  LoginDetailsType,
  LoginResponseType,
} from "../../Types/Authentication/LoginTypes";
import { RemoveRedEye, VisibilityOff } from "@mui/icons-material";
import moduleRoutes from "../../routes/moduleRouteList";
import { ResponseType } from "../../Types/ServicesType/servicesType";
import { AxiosError } from "axios";
import { storageKey } from "@utilifiles/methods/storage/storage";

// import AppleIcon from "@mui/icons-material/Apple";
// const initialValues = {
//   email: "admin@gmail.com",
//   password: "admin123",
// };
// const StyledOrText = styled(Typography)({
//   textAlign: "center",
//   width: "100%",
//   color: "#99a1b7",
//   fontSize: ".8rem",
//   marginTop: "5vh",
//   position: "relative",
//   "&::before, &::after": {
//     content: '""',
//     position: "absolute",
//     width: "35%",
//     height: "1px",
//     backgroundColor: "#99a1b7",
//   },
//   "&::before": {
//     top: "calc(50% - 1px)",
//     left: 0,
//   },
//   "&::after": {
//     top: "calc(50% - 1px)",
//     right: 0,
//   },
// });
// const StyledTextField = styled(TextField)({
//   width: "100%",
//   marginTop: "3.7vh",
// });
// const LoginMsgBox = styled(Box)({
//   width: "100%",
//   fontFamily: "poppins",
//   color: "#34bfa3",
//   marginTop: "4.7vh",
//   border: "2px solid #34bfa3",
//   borderRadius: "6px",
//   padding: "10px",
// });
const FailedLoginMsgBox = styled(Box)({
  width: "100%",
  color: "#f4516c",
  marginTop: "4vh",
  border: "2px solid #f4516c",
  borderRadius: "6px",
  padding: "10px",
});

function LoginForm() {
  const navigateto = useNavigate();
  const [loginStatus, setLoginstatus] = useState({
    status: true,
    message: "",
  });
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const { loggedIn } = useAuthentication();
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm<LoginDetailsType>();

  const clearWarning = () => {
    setLoginstatus({
      message: "",
      status: true,
    });
  };
 const onSuccess = async (
  result: ResponseType<{ user: LoginResponseType; message: string; status: boolean; photo: string }>
) => {
  if (result.responseIndicator === "success") {
    setLoginstatus({ message: "success", status: true });

    // 1️⃣ Fetch permissions BEFORE login()
    try {
      const permResult = await getPivilegesServices();
      if (permResult.responseIndicator === "success") {
        const perms = permResult.response?.permissions || [];
        localStorage.setItem(storageKey.data, JSON.stringify(perms));
        console.log("🟢 Privileges saved before reload:", perms);
      }
    } catch (err) {
      console.warn("Privilege fetch failed before reload", err);
    }

    // 2️⃣ Now call loggedIn()
    loggedIn({ ...result.response.user, photo: result?.response?.photo || "" });

    // 3️⃣ Then navigate and reload
    navigateto(moduleRoutes.root);
    window.location.reload();
  } else {
    setLoginstatus({
      message: result.responseMessage,
      status: false,
    });
  }
};

  const onError = (error: AxiosError<ResponseType<string | null>>) => {
    setLoginstatus({
      message: error?.response?.data?.responseMessage || error.message,
      status: false,
    });
  };

  const { mutate: login, isLoading } = useMutation(loginServices, {
    onSuccess,
    onError,
  });

  const handleLogin = (data: LoginDetailsType) => {
    login(data);
    clearWarning();
  };

  return (
    <Box className="h-full">
      <Box
        sx={{ height: "100%" }}
        className="flex flex-col justify-center items-center"
      >
        <Box
          width={{ width: "50%", padding: "0px" }}
          className="flex flex-col justify-center items-center"
        >
          <Typography
            sx={{
              fontSize: " 1.60rem",
              fontWeight: "700!important",
              color: "#67666e",
            }}
            variant="h1"
          >
            Login
          </Typography>
          {/* <Stack sx={{marginTop: "2.8vh",width:"100%",display:"flex",justifyContent:"space-between" }} direction="row" spacing={4}>
          <Button
            variant="outlined"
            sx={{ color: "#4b5675", border: "1px solid #dbdfe9" }}
          >
            <span className="me-2">
              <img width={"17px"} src="images/icons/google_icon.svg" alt="" />
            </span>
            sign with google
          </Button>
          <Button
            variant="outlined"
            sx={{ color: "#4b5675", border: "1px solid #dbdfe9" }}
          >
            <AppleIcon className="me-2" sx={{ color: "black" }} />
            sign with apple
          </Button>
        </Stack>
        <Box sx={{ width: "100%" }}>
          <StyledOrText>Or with email</StyledOrText>
        </Box> */}
          {loginStatus.status ? (
            <> </>
          ) : (
            <FailedLoginMsgBox>
              {loginStatus?.message?.charAt(0)?.toUpperCase() +
                loginStatus?.message?.slice(1) || "Error"}
            </FailedLoginMsgBox>
          )}
          <Box sx={{ marginTop: "4vh", width: "100%" }}>
            <div>
              <form
                onSubmit={handleSubmit(handleLogin)}
                className="flex flex-col gap-7"
              >
                <TextField
                  error={!!errors.email}
                  type="email"
                  label="Username"
                  {...register("email", { required: "Username required" })}
                  helperText={errors.email ? String(errors.email.message) : ""}
                  InputProps={{
                    sx: {
                      borderRadius: "1.2rem",
                    },
                  }}
                />
                <TextField
                  autoComplete="off"
                  error={!!errors.password}
                  type={showPassword ? "text" : "password"}
                  label="Password"
                  {...register("password", { required: "Password required" })}
                  helperText={
                    errors.password ? String(errors?.password?.message) : ""
                  }
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        <IconButton
                          onClick={() => {
                            setShowPassword((prev) => !prev);
                          }}
                        >
                          {showPassword ? <VisibilityOff /> : <RemoveRedEye />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: {
                      borderRadius: "1.2rem",
                    },
                  }}
                />
                <div className="flex flex-col justify-end items-end">
                  {/* <Link
                    to={`/${moduleRoutes.authentication}/${authenticationRouteList.forgotPassword}`}
                    // onClick={() => console.log("hello")}
                    className="bg-transparent p-2 ring-offset-0 text-sky-600"
                  >
                    Forgot password ?
                  </Link> */}
                </div>
                <Button
                  sx={{
                    width: "100%",
                    backgroundColor: "#0B3866",
                    padding: "1vh",
                    borderRadius: "1.2rem",
                  }}
                  type="submit"
                  variant="contained"
                  disabled={isLoading}
                  endIcon={
                    isLoading && (
                      <CircularProgress size={20} sx={{ color: "white" }} />
                    )
                  }
                >
                  Sign In
                </Button>
              </form>
            </div>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
export default LoginForm;
